import {Component, Input} from '@angular/core';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
import {NotificationService} from "../../notification.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-copy-to-clipboard',
    templateUrl: './copy-to-clipboard.component.html',
    styleUrls: ['./copy-to-clipboard.component.scss'],
    standalone: false
})
export class CopyToClipboardComponent {

  @Input() value: string;
  @Input() tooltip: string;

  constructor(
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {
  }


  onCopyClicked() {
    this.notificationService.info(
      this.translateService.stream(marker('Value copied!')),
    );
  }
}
